import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../app/store';

import './ErrorPage.css';
import error from '../../images/error.svg';
import errorCar from '../../images/sadCar.svg';

interface InjectedProps {
    paymentError?: boolean;
}

export type Props = InjectedProps;

export class ErrorPage extends React.PureComponent<Props> {

    componentDidMount() {
        let appEventData = 'AppEventData';
        window[appEventData].push({
            event: 'stepLoaded',
            page: {
                'pageName': 'ie:secure:my-aviva:driving-school:' + 
                    `${this.props.paymentError ? 'payment-error' : 'error'}`,
                'channel': 'secure'
              }
        });
    }

    render() {
        const { paymentError } = this.props;
        const aviva = import.meta.env.VITE_DS_AVIVA_URL;
        return (
            <div className="errorPage-container" data-testid="error-page">
                <img className="error-car" src={errorCar} alt="error car"/>
                {!paymentError &&
                    <h1 className="text__center">
                        Oh beep, something's not right
                    </h1>
                }
                {paymentError &&

                    <h1 className="text__center">
                        We cannot process your payment at this time
                    </h1>

                }
                <div>
                    <img src={error} />
                    <h3 className="error-text">
                        <strong>Please try booking again later</strong>
                    </h3>
                    <span className="error-text">Your details have not been saved.</span>
                </div>

                <br />

                <div className="aviva-button">
                    <a className="btn-link" href={aviva} tabIndex={-1}>
                        <button
                            className="a-button a-button--primary a-button--full-width"
                        >
                            Return to Aviva.ie
                        </button>
                    </a>
                </div>
            </div>

        );
    }
}

export function mapStateToProps(state: RootState) {
    return {
        paymentError: !!state.payment.paymentError
    };
}

export default connect<InjectedProps>(mapStateToProps)(ErrorPage);